"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

require("../css/toast_notification.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ToastNotification =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToastNotification, _React$Component);

  function ToastNotification(props) {
    var _this;

    _classCallCheck(this, ToastNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToastNotification).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "UNSAFE_componentWillMount", function () {
      _this.timeout = setTimeout(function () {
        _this.closeToast();
      }, _this.props.timeout * 1000);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "componentWillUnmount", function () {
      clearTimeout(_this.timeout);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "closeToast", function () {
      _this.setState({
        show: false
      }, _this.props.onClose(_this.props.id));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOver", function () {
      clearTimeout(_this.timeout);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMouseOut", function () {
      if (_this.state.show) {
        _this.timeout = setTimeout(function () {
          _this.closeToast();
        }, _this.props.timeout * 1000);
      }
    });

    _this.state = {
      show: true
    };
    return _this;
  }

  _createClass(ToastNotification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          i18n = _this$props.i18n,
          id = _this$props.id,
          text = _this$props.text,
          type = _this$props.type,
          onClose = _this$props.onClose,
          otherProps = _objectWithoutProperties(_this$props, ["i18n", "id", "text", "type", "onClose"]);

      var typeClassName = "vn-toast__type vn-toast__type--".concat(type);
      return _react.default.createElement(_reactTransitionGroup.CSSTransition, _extends({}, otherProps, {
        in: this.state.show,
        unmountOnExit: true,
        classNames: "vn-toast",
        timeout: 500
      }), _react.default.createElement("div", {
        className: "vn-toast",
        onMouseOver: this.handleMouseOver,
        onFocus: this.handleMouseOver,
        onMouseOut: this.handleMouseOut,
        onBlur: this.handleMouseOut,
        role: "presentation"
      }, _react.default.createElement("div", {
        className: typeClassName
      }), _react.default.createElement("p", {
        className: "vn-toast__text"
      }, text), _react.default.createElement("button", {
        className: "vn-toast__close",
        onClick: this.closeToast,
        type: "button"
      }, i18n.close)));
    }
  }]);

  return ToastNotification;
}(_react.default.Component);

ToastNotification.propTypes = {
  i18n: _propTypes.default.shape({
    close: _propTypes.default.string
  }),
  id: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func,
  text: _propTypes.default.string.isRequired,
  timeout: _propTypes.default.number,
  type: _propTypes.default.oneOf(['positive', 'negative', 'informative']).isRequired
};
ToastNotification.defaultProps = {
  i18n: {
    close: 'close'
  },
  onClose: function onClose() {},
  timeout: 5
};
ToastNotification.displayName = 'ToastNotification';
var _default = ToastNotification;
exports.default = _default;